<mat-selection-list [multiple]="false" (selectionChange)="selectedStaff($event)" (keydown)="handleKeyDown($event)">
  <mat-list-option *ngFor="let staff of stafflist | staffSearch: data.search let i = index" [value]="staff.email" [selected]="i === selectedIndex">
    <div class="user">
      <div class="profilepicture"><img src="{{staff.imageUrl}}"></div>
      <div class="username">{{staff.firstName}} {{staff.lastName}}</div>
      <div class="email">{{staff.email}}</div>
    </div>  
  </mat-list-option>
</mat-selection-list>

